/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setpoint_Temp_DisconnectedInputs */



/**
* | output |
* | --- |
* | "All elements in the room are disconnected" |
*
* @param {Setpoint_Temp_DisconnectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const setpoint_temp_disconnected = /** @type {((inputs?: Setpoint_Temp_DisconnectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setpoint_Temp_DisconnectedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("All elements in the room are disconnected")
	return /** @type {LocalizedString} */ ("Tous les éléments de la pièce sont déconnectés")
});